/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDetentionHistChg.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/detention-hist-chg";

export class AutogenModelDetentionHistChg<RowType extends ModelRow> extends Endpoint<RowType, RowDetentionHistChgFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDetentionHistChg extends ModelRow<RowDetentionHistChgFields> {
	constructor(values?: Partial<RowDetentionHistChgFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDetentionHistChgFields {
	billable: string;
	charge_amount: number;
	charge_amount_c: string;
	charge_amount_d: Date;
	charge_amount_n: number;
	charge_amount_r: number;
	charge_id: string;
	company_id: string;
	customer_id: string;
	descr: string;
	detention_hist_id: string;
	end_date: Date;
	id: string;
	other_charge_id: string;
	rate: number;
	sequence: number;
	start_date: Date;
	status: string;
	stop_movement_sequence: number;
	units: number;
}

